export class CreatePrivilegioDto {}
